import {toast} from "react-toastify";

export default (text, duration = 4000, type = 'success') => {
  toast(text, {
    position: toast.POSITION.TOP_RIGHT,
    autoClose: duration,
    type
  })
}
